import { ocapiClient } from '../../../../api-clients/ocapi/client';
import { isEmptyArray } from '../../../../utils/array-utils';
import { createFetchedDataRecord } from '../../../../utils/fetched-data/create-fetched-data-record';
import { createOrGetFetchedState } from '../../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../utils/load-data-from-api';
import { updateObject } from '../../../../utils/object-utils';
import { salesDataDomainStore } from '../../store';
export const loadTicketPricesForShowtime = async (showtimeId, reloadCachedData = false) => {
    const state = createOrGetFetchedState(salesDataDomainStore.data.ticketPricesByShowtimeId, showtimeId);
    await loadDataFromApi({
        api: () => ocapiClient.instance.v1.sales.masterData.ticketPrices.getForShowtime(showtimeId),
        state,
        cacheDuration: getCacheDuration('tickets'),
        reloadCachedData,
        onSuccess: (response, cacheDuration) => onSuccess(response, cacheDuration, showtimeId)
    });
};
const onSuccess = (response, cacheDuration, showtimeId) => {
    const { ticketPrices, relatedData } = response;
    if (isEmptyArray(ticketPrices))
        throw new Error(`No ticket prices found for showtime ${showtimeId}.`);
    assignRelatedData(relatedData, cacheDuration);
    return ticketPrices;
};
const assignRelatedData = (relatedData, cacheDuration) => {
    const { ticketTypes, items, discounts } = relatedData;
    updateObject(salesDataDomainStore.data.ticketTypesById, createFetchedDataRecord(ticketTypes, 'id', cacheDuration));
    updateObject(salesDataDomainStore.data.itemsById, createFetchedDataRecord(items, 'id', cacheDuration));
    updateObject(salesDataDomainStore.data.discountsById, createFetchedDataRecord(discounts, 'id', cacheDuration));
};
